import { PostGeneratorScreen } from '@/components/profile/post-generator-screen';

export default function ProfilePostGeneratorPage() {
  return <PostGeneratorScreen />;
}
